var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHistoryPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189-187v-582 582Zm100-422h382v-60H289v60Zm0 161h209.524q19.229-18.092 40.763-33.046T585-508H289v60Zm0 161h123.661q3.339-16 7.971-30.415Q425.263-331.831 432-347H289v60ZM189-92q-38.775 0-66.388-27.906Q95-147.812 95-187v-582q0-38.775 27.612-66.387Q150.225-863 189-863h582q39.188 0 67.094 27.613Q866-807.775 866-769v267q-21.746-11.737-45.873-19.368Q796-529 771-533.029V-769H189v582h221q1 26 7 49t16 46H189ZM720-8q-75.198 0-132.099-45Q531-98 514-163h106q11 25 37.318 43 26.318 18 62.682 18 50.129 0 85.564-35.436Q841-172.871 841-223q0-50.486-35.5-85.243T720-343q-22.367 0-40.908 6.55T648-318h46v95H488v-206h94v41q27.421-22.895 62.65-36.447Q679.879-438 720-438q89.925 0 152.463 62.553Q935-312.894 935-223.442q0 89.453-62.537 152.447Q809.925-8 720-8Z",
    fill: "#1D5FE0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryPaper);
export default __webpack_public_path__ + "static/media/historyPaper.ee66e9db48c5c9e18aa000d19fd7bbe3.svg";
export { ForwardRef as ReactComponent };